import Vue from 'vue';
import Component from 'vue-class-component';
import ExperienceBox from 'components/ExperienceBox';
import lodash from 'lodash';

@Component({
  props: {
    campaign: {
      type: Object,
      required: true,
    },
    travel_list: {
      type: Array,
      required: true,
    },
  },
  components: {
    ExperienceBox,
  },
})
export default class CustomCampaignTravelActivitiesComponent extends Vue {
  activityList = {};
  activitiesOrder = 'discount';

  mounted() {
    this.activityList = this.formatActivities();
    this.updateActivitiesList();
  }

  /**
   * Add another the property 'activity' inside 'custom_campaign_activities'
   * as expected by 'ExperienceBox':
   * from custom_campaign_activities = [ {k: v} ] to
   * custom_campaign_activities = [ {activity: {k: v}} ]
   */
  formatActivities() {
    if (this.campaign) {
      return this.travel_list.map(activity => {
        return { activity };
      });
    }
    return {};
  }

  /**
   * Sort ActivitiesList by activitiesOrder value
   */
  updateActivitiesList() {
    // Set default values for rating and discount
    this.activityList = this.activityList.map(item => {
      item.activity.rating = parseFloat(item.activity.rating) || 0;
      item.activity.discount =
        parseFloat(item.activity.campaign_discounted_percentage) || 0;
      return item;
    });

    /**
     * use lodash orderBy function for sorting the activityList
     * the iteratee value needs to be passed from an arrow function because of the
     * structure of activityList
     */
    if (this.activitiesOrder === 'rating_desc') {
      this.activityList = lodash.orderBy(
        this.activityList,
        item => item.activity.rating,
        ['desc'],
      );
    } else if (this.activitiesOrder === 'price') {
      this.activityList = lodash.orderBy(
        this.activityList,
        item => parseFloat(item.activity.price),
        ['asc'],
      );
    } else if (this.activitiesOrder === 'discount') {
      this.activityList = lodash.orderBy(
        this.activityList,
        item => item.activity.discount,
        ['desc'],
      );
    }
  }
}
